<script>
import Router from '@/router/index.js'
import 'bulma/css/bulma.css'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, fetchSignInMethodsForEmail, sendEmailVerification, sendPasswordResetEmail, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth'
import { signUpQnQ } from '@/api/FirebaseUserWrapper.js'
const auth = getAuth(firebaseApp)
require('../../css/style.css')

export default {
  components: {},
  props: [
    'isAnonymous',
    'invitedEmail'
  ],
  data () {
    return {
      isCreatedUser: false,
      password: '',
      email: '',
      alertMsg: '',
      hasPassword: true, // passwordを覚えていればTrue
      isResetPassword: false, // passwordをresetしてらTrue
      inputType: 'password' // 'password' or 'text'
    }
  },
  async created () {
    this.email = this.invitedEmail
    // パスワード再発行ユーザの確認
    if (this.isAnonymous) {
      await this.confirmPasswordResetUser()
    }
  },
  methods: {
    passwordLogin: async function () {
      this.alertMsg = ''
      if (!this.email.includes('@')) {
        this.alertMsg = 'メールアドレスが不正です'
        return
      }
      if (this.password.length <= 5) {
        this.alertMsg = 'passwordが短すぎます'
        return
      }
      // すでにSINGUP済かチェック
      try {
        const signInMethods = await fetchSignInMethodsForEmail(auth, this.email)
        // すでにサインアップ済ならTrue
        this.isCreatedUser = (signInMethods.length !== 0)
      } catch (error) {
        console.error(error)
        this.alertMsg = '情報の取得に失敗しました'
        return
      }
      // すでにSIGNUP済み
      if (this.isCreatedUser) {
        console.log('既存ユーザのSign IN')
        try {
          const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password)
          const user = userCredential.user
          if (!user.emailVerified) {
            // メアド確認終わってない
            this.alertMsg = 'メール確認が完了していません'
            return
          } else {
            // メアド認証が完了している
            this.$emit('updateUserInfo')
          }
        } catch (error) {
          console.log(error)
          this.password = ''
          this.alertMsg = 'パスワードが間違っています'
        }
      } else {
      // SINGUP前
        console.log('新規ユーザのSign UP')
        try {
          const userCredential = await createUserWithEmailAndPassword(auth, this.email, this.password)
          // Signed in
          let user = userCredential.user
          user.displayName = this.email.substr(0, this.email.indexOf('@'))
          await signUpQnQ(user)
          await sendEmailVerification(auth.currentUser)
          this.$emit('updateUserInfo')
        } catch (error) {
          console.log(error)
          this.alertMsg = 'アカウント作成に失敗しました'
        }
      }
    },
    resetPasswordLogin: async function () {
      this.alertMsg = ''
      if (!this.email.includes('@')) {
        this.alertMsg = 'メールアドレスが不正です'
        return
      }
      if (this.password.length <= 5) {
        this.alertMsg = 'passwordが短すぎます'
        return
      }
      // すでにSINGUP済かチェック
      try {
        const signInMethods = await fetchSignInMethodsForEmail(auth, this.email)
        // すでにサインアップ済ならTrue
        this.isCreatedUser = (signInMethods.length !== 0)
      } catch (error) {
        console.error(error)
        this.alertMsg = '情報の取得に失敗しました'
        return
      }
      // SINGUP前ならパスワード再発行ではない
      if (!this.isCreatedUser) {
        this.alertMsg = '新規登録を行ってください'
        this.isResetPassword = false
        return
      }
      // すでにSIGNUP済み && パスワードがある
      console.log('パスワード再発行処理')
      try {
        const actionCode = this.$route.query.oobCode
        await confirmPasswordReset(auth, actionCode, this.password)
      } catch (error) {
        console.error(error)
        this.alertMsg = '再発行メールの有効期限が切れています'
        this.isResetPassword = false
      }
      // パスワードのresetが完了したのでSING IN
      try {
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password)
        const user = userCredential.user
        if (!user.emailVerified) {
          // メアド確認終わってない
          this.alertMsg = 'メール確認が完了していません'
          return
        } else {
          // メアド認証が完了している
          Router.push({ path: '/' })
          this.isResetPassword = false
        }
      } catch (error) {
        console.log(error)
        this.email = ''
        this.alertMsg = '予期しないエラーが発生しました'
        this.isResetPassword = false
      }
    },
    lostPassword () {
      this.hasPassword = !this.hasPassword
      this.alertMsg = ''
    },
    async sendPasswordReset () {
      this.alertMsg = ''
      if (!this.email.includes('@')) {
        this.alertMsg = 'メールアドレスが不正です'
        return
      }
      try {
        await sendPasswordResetEmail(auth, this.email)
        this.alertMsg = '再発行メールを送信しました。メールから再認証してください'
      } catch (error) {
        console.error(error)
        this.alertMsg = '発行に失敗しました'
      }
    },
    async confirmPasswordResetUser () {
      const actionCode = this.$route.query.oobCode
      if (actionCode && this.$route.query.mode === 'resetPassword') {
        console.log('========= welcom to the confirmPasswordResetUser =========')
        try {
          await verifyPasswordResetCode(auth, actionCode)
          this.isResetPassword = true
        } catch (error) {
          // 確認メールを一定時間クリックしないと無効化されてエラーになる
          console.log(error)
        }
      }
    },
    switchType () {
      this.inputType = (this.inputType === 'password') ? 'text' : 'password'
    }
  }
}
</script>
<style scoped>
.is-size-8 {
  font-size: 0.5rem !important;
}
.control .icon {
  pointer-events: all;
}
</style>
<template>
  <div class='password'>
    <!-- SignUp & SignIN -->
    <div class="signup-login" v-if="!isResetPassword">
      <div class="field">
        <label class="label">Email</label>
        <p class="control has-icons-left has-icons-right">
          <input class="input" type="email" placeholder="Email" v-model="email">
          <span class="icon is-small is-left">
            <i class="fa-solid fa-envelope"></i>
          </span>
          <span class="icon is-small is-right">
            <i class="fa-solid fa-check"></i>
          </span>
        </p>
      </div>
      <div class='has-password' v-if="hasPassword">
        <div class="field">
          <label class="label">Password</label>
          <p class="control has-icons-left has-icons-right">
            <input class="input" :type="inputType" placeholder="5文字以上" v-model="password">
            <span class="icon is-small is-left">
              <i class="fa-solid fa-lock"></i>
            </span>
            <span class="icon is-small is-right" @click="switchType()">
              <i class="fa-solid fa-eye" v-if="inputType==='password'"></i>
              <i class="fa-solid fa-eye-slash" v-else></i>
            </span>
          </p>
        </div>
        <p class="help is-danger has-text-centered">{{alertMsg}}</p>
        <div class="button is-link is-outlined has-text-weight-bold" v-on:click="passwordLogin">
          &nbsp;
          &nbsp;
          <span>Login</span>
          &nbsp;
          &nbsp;
        </div>
      </div>
      <div class="lost-password" v-else>
        <p class="help is-danger has-text-centered">{{alertMsg}}</p>
        <div class="button is-danger is-outlined has-text-weight-bold" v-on:click="sendPasswordReset()">
          &nbsp;
          &nbsp;
          <span>再発行メールを送る</span>
          &nbsp;
          &nbsp;
        </div>
      </div>
      <br>
      <br>
      <a class="text has-text-centered is-underlined has-text-link" @click="lostPassword()">
        <span v-if="hasPassword">パスワードを忘れた方はこちら</span>
        <span v-else>元のログイン画面に戻る</span>
      </a>
    </div>
    <!-- パスワード再発行ユーザ -->
    <div class="reset-login" v-else>
      <div class="field">
        <label class="label">Email</label>
        <p class="control has-icons-left has-icons-right">
          <input class="input" type="email" placeholder="Email" v-model="email">
          <span class="icon is-small is-left">
            <i class="fa-solid fa-envelope"></i>
          </span>
          <span class="icon is-small is-right">
            <i class="fa-solid fa-check"></i>
          </span>
        </p>
      </div>
      <div class="has-password">
        <div class="field">
          <label class="label">Password再発行</label>
          <p class="control has-icons-left has-icons-right">
            <input class="input" :type="inputType" placeholder="5文字以上" v-model="password">
            <span class="icon is-small is-left">
              <i class="fa-solid fa-lock"></i>
            </span>
            <span class="icon is-small is-right" @click="switchType()">
              <i class="fa-solid fa-eye" v-if="inputType==='password'"></i>
              <i class="fa-solid fa-eye-slash" v-else></i>
            </span>
          </p>
        </div>
        <p class="help is-danger has-text-centered">{{alertMsg}}</p>
        <div class="button is-danger is-outlined has-text-weight-bold" v-on:click="resetPasswordLogin">
          &nbsp;
          &nbsp;
          <span>再Login</span>
          &nbsp;
          &nbsp;
        </div>
      </div>
      <br>
      <br>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/join/PasswordLogin.vue